var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10739",
    "data-name": "Group 10739",
    transform: "translate(-519 -8586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44702",
    "data-name": "Path 44702",
    d: "M0,0H50V50H0Z",
    transform: "translate(519 8586)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44700",
    "data-name": "Path 44700",
    d: "M25.651,38.575A22.616,22.616,0,0,1,6.055,4.727,3.318,3.318,0,0,1,8.521,3.094a3.417,3.417,0,0,1,2.889.977l6.236,6.238a3.407,3.407,0,0,1,0,4.822l-.586.6a3.848,3.848,0,0,0,0,5.435l3.417,3.419a3.939,3.939,0,0,0,5.435,0l.576-.576a3.417,3.417,0,0,1,4.824,0l6.236,6.236a3.417,3.417,0,0,1,.977,2.891,3.318,3.318,0,0,1-1.633,2.461,22.449,22.449,0,0,1-11.24,2.982M8.976,5.051a1.986,1.986,0,0,0-.2.012,1.331,1.331,0,0,0-.993.658A20.611,20.611,0,0,0,35.9,33.865a1.331,1.331,0,0,0,.658-.993,1.45,1.45,0,0,0-.413-1.228l-6.236-6.236a1.424,1.424,0,0,0-2.014,0l-.576.576a5.972,5.972,0,0,1-8.245,0l-3.425-3.425a5.841,5.841,0,0,1,0-8.243l.6-.6a1.424,1.424,0,0,0,0-2.014L10,5.476a1.45,1.45,0,0,0-1.029-.425",
    transform: "translate(522.932 8589.938)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.0f7473c11db5b0e24198b531aafa14aa.svg";
export { ForwardRef as ReactComponent };